module.exports = __webpack_public_path__ + "media/images/lb/170-ba1abe4135ff13a07ce369effc3d06ac.svg";